import { environment } from '../../environments/environment';

/** True when apiBaseUrl points at the local JVM (dev); those requests must stay relative so `/api` is proxied. */
function isLocalDevBackendBase(base: string): boolean {
  return /^https?:\/\/(localhost|127\.0\.0\.1):8080\/?$/i.test(base.trim());
}

/**
 * In dev, `http://localhost:8080/api/...` bypasses the Angular proxy and hits CORS.
 * Treat local backend base like an empty base so callers use same-origin `/api/...`.
 */
function effectiveApiBase(): string {
  const raw = environment.apiBaseUrl.trim().replace(/\/$/, '');
  if (!raw || isLocalDevBackendBase(raw)) {
    return '';
  }
  return raw;
}

export function apiUrl(path: string): string {
  const base = effectiveApiBase();
  const p = path.startsWith('/') ? path : `/${path}`;
  return base ? `${base}${p}` : p;
}
